const sectionCardVitalSurroundCss = `
[data-type='section-card-vital-surround'] [data-attribute='card-container'] {
  color: var(--color-text, #000000);
}

[data-type='section-card-vital-surround'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-vital-surround'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-vital-surround'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-card-vital-surround'] [data-attribute='card-container'] .container-page .container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[data-type='section-card-vital-surround'] .title-card {
  margin-bottom: 24px;
  text-align: center;
}

[data-type='section-card-vital-surround'] .title-card[data-show-title='false'] {
  display: none !important;
}

[data-type='section-card-vital-surround'] .title-card h2 {
  font-size: 24px;
  line-height: 1.4;
  margin: 0 !important;
}

[data-type='section-card-vital-surround'] .wrap-content {
  max-width: 1120px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  position: relative;
}

[data-type='section-card-vital-surround'] .wrap-content .main-item {
  max-width: 35%;
  min-height: 548px;
  display: flex;
  justify-content: center;
  align-items: center;
}

[data-type='section-card-vital-surround'] .wrap-content .main-item img {
  width: 100%;
  height: auto;
  display: block;
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround {
  position: absolute;
  width: 228px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(1) {
  top: 14%;
  left: 10%;
  transform: translate(0%, -50%);
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(2) {
  top: 14%;
  right: 10%;
  transform: translate(0%, -50%);
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(3) {
  top: 50%;
  left: 3%;
  transform: translate(0%, -50%);
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(4) {
  top: 50%;
  right: 3%;
  transform: translate(0%, -50%);
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(5) {
  bottom: 14%;
  left: 10%;
  transform: translate(0%, 50%);
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(6) {
  bottom: 14%;
  right: 10%;
  transform: translate(0%, 50%);
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround .wrap-img-item {
  width: 60%;
  aspect-ratio: 1/1;
  border-radius: 50%;
  overflow: hidden;
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround .wrap-img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

[data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround .text-item {
  font-size: 16px;
  line-height: 1.4;
  margin: 0 !important;
  text-align: center;
}

@container (max-width: 768px) {
  [data-type='section-card-vital-surround'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-vital-surround'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-vital-surround'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-card-vital-surround'] .title-card h2 {
    font-size: 20px;
  }

  [data-type='section-card-vital-surround'] .wrap-content .main-item {
    max-width: 40%;
    min-height: auto;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround {
    width: 150px;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(1) {
    top: 14%;
    left: 12%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(2) {
    top: 14%;
    right: 12%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(3) {
    top: 50%;
    left: 6%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(4) {
    top: 50%;
    right: 6%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(5) {
    bottom: 14%;
    left: 12%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(6) {
    bottom: 14%;
    right: 12%;
  }
}

@container (max-width: 640px) {
  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround {
    width: 100px;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(1) {
    top: 14%;
    left: 10%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(2) {
    top: 14%;
    right: 10%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(3) {
    top: 50%;
    left: 2%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(4) {
    top: 50%;
    right: 2%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(5) {
    bottom: 14%;
    left: 10%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround:nth-child(6) {
    bottom: 14%;
    right: 10%;
  }

  [data-type='section-card-vital-surround'] .wrap-content .wrap-items .item-surround .text-item {
    font-size: 14px;
  }
}
`;
export default sectionCardVitalSurroundCss;
